<template>
  <section class="user-registration-container p-2">

    <!-- User Registration Form -->
    <div class="form-container p-3">
      <div class="text-center mb-4">
        <h1 class="text-primary">الإعدادات العامة</h1>
      </div>
      <div class="row my-2">
        <div  class="radio-choices my-2">     
          <h5 >إضافة خيارات جديدة</h5>
          <div class="form-check form-check-inline">
              <input v-model="addChoice.type" class="form-check-input" type="radio" id="add-choice-city" value="1" />
              <label class="form-check-label" for="add-choice-city">إضافة مدينة</label>
          </div>
          <div class="form-check form-check-inline">
              <input v-model="addChoice.type" class="form-check-input" type="radio" id="add-choice-depart" value="2" />
              <label class="form-check-label" for="add-choice-depart">إضافة معبر</label>
          </div>
          <div class="form-check form-check-inline">
              <input v-model="addChoice.type" class="form-check-input" type="radio" id="add-choice-nationality" value="3" />
              <label class="form-check-label" for="add-choice-nationality">إضافة جنسية</label>
          </div>
          <div class="form-check form-check-inline">
              <input v-model="addChoice.type" class="form-check-input" type="radio" id="add-choice-transtype" value="4" />
              <label class="form-check-label" for="add-choice-transtype">إضافة نوع مركبة</label>
          </div>
          <div class="form-check form-check-inline">
              <input v-model="addChoice.type" class="form-check-input" type="radio" id="add-choice-transmade" value="5" />
              <label class="form-check-label" for="add-choice-transmade">إضافة مًصنّع سيارات</label>
          </div>
        </div>
        <div class="row">
          <div class="me-2 col-md-4 col-5">
            <input type="text" class="form-control " id="choice-name" v-model="addChoice.name" :placeholder="addChoice.placeholder[addChoice.type]" />
          </div>
          <div class="me-2 col-md-4 col-5">
            <input type="text" class="form-control me-2 col-md-4 col-5" id="choice-eng-name" v-model="addChoice.engName" placeholder="Repeat in English text (أعد الكتابة بالإنجليزية)" />
          </div>
          <div v-if="addChoice.type == 4" class="me-2 col-2 mb-2">
            <input  type="text" class="form-control " id="choice-receipt-value" v-model="addChoice.receiptValue" placeholder="اكتب قيمة الإيصال" />
          </div>
          <div class="col-md-2 col-3 ">
            <button type="button" class="btn btn-primary p-2 w-100" @click="addNewChoice()">إضافة</button>
          </div>
        </div>
      </div>

      <hr />

      <div class="row my-2">
        <!-- Receipt value -->
        <div class="my-2" >
            <label for="report-type fz-2" class="form-label">تعديل قيمة الإيصال المالي (حسب نوع المركبة)</label>
            <select class="form-select w-50" id="choice-type" v-model="editValues.receipt.type"
                @change="resetValues()" required="required" >
                <option value="1">
                    خاصة
                </option>
                <option value="2">
                    إسعاف 
                </option>
                <option value="3">
                    نقل ركاب 
                </option>
                <option value="4">
                    نقل ثقيل
                </option>
                <option value="5">
                    نقل ثقيل بمقطورة مجرورة
                </option>
            </select>
        </div>
        <div class="d-flex w-50">
          <input type="text" class="form-control w-25 me-2" id="edit-values" v-model="editValues.receipt.value" placeholder="" />
          <button type="button" class="btn btn-primary  col-2">حفظ</button>
        </div>
      </div>
      <!--  -->
      <div class="row my-3">
        <h6 >أقصى مدة لبقاء المركبة خارج البلد المصدر</h6>
        <div class="d-flex w-50">
          <input type="text" class="form-control w-25 me-2" id="edit-values" v-model="editValues.trypticInterval" placeholder="" />
          <button type="button" class="btn btn-primary  col-2">حفظ</button>
        </div>
      </div>

      <hr />
      <!--  -->
      <div class="row my-2">
        <h5>المستندات المطلوبة</h5>
        <div class="my-2">
          <h6 class="">المستندات المطلوبة على الطلب الأساسي حسب نوع المركبة</h6>
          <div class="my-2">
            <!-- <label for="report-type fz-2" class="form-label"></label> -->
            <select class="form-select w-50" id="choice-type" required="required">
              <option value="" selected disabled>
                اختر نوع المركبة
              </option>
              <option v-for="trans in getTransTypes" :key="trans.id" :value="trans.id">
                {{ trans.name }}
              </option>
             
            </select>
          </div>
          <div class="my-2 fs-7">
            <div v-for="doc in allTransDocs" :key="doc.id" class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" :id="'except-doc-' + doc.id" :value="doc.id" :disabled="true">
              <label class="form-check-label" :for="'except-doc-' + doc.id">{{ doc.name }}</label>
            </div>
          </div>
          <button type="button" class="btn btn-primary px-3">حفظ</button>
        </div>
        <hr class="w-50">

        <div class="my-2">
          <h6 class="">المستندات المطلوبة على الاستثناءات</h6>
          <div class="my-2">
            <select class="form-select w-50" id="choice-type" required="required">
              <option value="" selected disabled>
                اختر نوع الستناء
              </option>
              <option v-for="except in getExceptTypes" :key="except.id" :value="except.id">
                {{ except.name }}
              </option>
            </select>
          </div>
          <div class="my-2 fs-7">
            <div v-for="doc in allExceptDocs" :key="doc.id" class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" :id="'except-doc-' + doc.id" :value="doc.id" :disabled="true">
              <label class="form-check-label" :for="'except-doc-' + doc.id">{{ doc.name }}</label>
            </div>
          </div>
          <button type="button" class="btn btn-primary px-3">حفظ</button>
        </div>
        <hr class="w-50">

        <div class="my-2">
          <h6 class="">إضافة مستند جديد</h6>
          <div class="row">
            <div class="me-2 col-md-3 col-5">
              <input type="text" class="form-control " id="doc-name" v-model="addDoc.name"
                placeholder="اسم المستند" />
            </div>
            <div class="me-2 col-md-3 col-5">
              <input type="text" class="form-control me-2 col-md-4 col-5" id="doc-eng-name"
                v-model="addDoc.engName" placeholder="Repeat in English text (أعد الكتابة بالإنجليزية)" />
            </div>
            <div class="radio-docs col-md-4 col-6">
              <div class="form-check form-check-inline">
                <input v-model="addDoc.typeKey" class="form-check-input" type="radio" id="add-doc-app" value="1" />
                <label class="form-check-label" for="add-doc-app">متعلق بالطلب الأساسي</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model="addDoc.typeKey" class="form-check-input" type="radio" id="add-doc-exc" value="2" />
                <label class="form-check-label" for="add-doc-exc">متعلق بالإستثناءات</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model="addDoc.typeKey" class="form-check-input" type="radio" id="add-doc-all" value="0" />
                <label class="form-check-label" for="add-doc-all">للكل</label>
              </div>
            </div>
            <div v-if="addDoc.typeKey < 2" class="my-2 fs-7">
              <div v-for="trans in getTransTypes" :key="trans.id" class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" v-model="addDoc.relatedTo.transIds" :id="'except-trans-' + trans.id" :value="trans.id" >
                <label class="form-check-label" :for="'except-trans-' + trans.id">{{ trans.name }}</label>
              </div>
            </div>
            <div v-if="addDoc.typeKey == 0 || addDoc.typeKey == 2" class="my-2 fs-7">
              <div v-for="except in getExceptTypes" :key="except.id" class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" v-model="addDoc.relatedTo.exceptIds" :id="'except-except-' + except.id" :value="except.id" >
                <label class="form-check-label" :for="'except-except-' + except.id">{{ except.name }}</label>
              </div>
            </div>
            <div class="col-md-2 col-3 ">
              <button type="button" class="btn btn-primary p-2 w-100" @click="addNewDoc()">إضافة</button>
            </div>
          </div>
        </div>
      </div>



    </div>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import router from '@/router';
export default {
  data() {
    return {
      addChoice: {
        type: "",
        name: "",
        engName: "",
        receiptValue: "",
        placeholder : [
          "",
          "اكتب اسم المدينة",
          "اكتب اسم المعبر",
          "اكتب الجنسية الجديدة",
          "اكتب نوع المركبة الجديد",
          "اكتب مُصنّع المركبات الجديد",
        ]
      },
      editValues: {
        receipt: {
          type: "1",
          value: "10"
        },
        trypticInterval: "180",
      },
      addDoc: {
        typeKey: "1",
        name: "",
        engName: "",
        relatedTo: {
          transIds: [],
          exceptIds: []
        }
      },
      allTransDocs: [],
      allExceptDocs: [],

      alert: null, // Object to hold alert messages
    };
  },
  created() {
    this.fetchAllOptions();
  },
  computed: {
    ...mapGetters(['getDeparts', 'getGroups', 'getUser', 'getTransTypes', 'getExceptTypes'])
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchGroups',
      'fetchUser',
      'fetchTransTypes',
      'fetchExceptTypes',
    ]),
    /********************************/
    
    /** */
    async fetchAllOptions() {
      if (this.getTransTypes.length == 0) {
        await this.fetchTransTypes();
      }
      if (this.getExceptTypes.length == 0) {
        await this.fetchExceptTypes();
      }
        try {
        const [transDocsResponse, exceptDocsResponse] = await Promise.all([
          this.$axios.get("api/employee/docs/allapplicantdocs"),
          this.$axios.get("api/employee/docs/allexceptdocs"),
        ]);

        if (transDocsResponse.data.isSuccess) {
          this.allTransDocs = transDocsResponse.data.docTypes;
        }
        if (exceptDocsResponse.data.isSuccess) {
          this.allExceptDocs = exceptDocsResponse.data.docTypes;
        }
      } catch (error) {
        console.error("Error fetching docs types and groups:", error);
      }
    },
    /********************************/
    /** */
    async addNewChoice() {
      const choiceURL = [
        "",
        "api/employee/cities/addcity",
        "api/employee/departs/adddepart",
        "api/employee/nationalities/addnation",
        "api/employee/trans/addtype",
        "api/employee/trans/addmade",
      ]
      try {
        const response = await this.$axios.post(choiceURL[this.addChoice.type], this.addChoice);

        if (response.data.isSuccess) {
          this.$tempAlert(response.data.msg || "تم تحديث الإضافة بنجاح.", "success");
        } else {
          this.$tempAlert(response.data.msg || "فشل العملية.");
        }
      } catch (error) {
        console.error("Error (Server)", error);
        this.$tempAlert(error.response?.data.msg ||"حدث خطأ مشكلة من الخادم.");
      }
    },
    /********************************/
    /** */
    async addNewDoc() {
      try {
        const response = await this.$axios.post("api/employee/docs/add", this.addDoc);

        if (response.data.isSuccess) {
          this.$tempAlert(response.data.msg || "تم تحديث الإضافة بنجاح.", "success");
        } else {
          this.$tempAlert(response.data.msg || "فشل العملية.");
        }
      } catch (error) {
        console.error("Error (Server)", error);
        this.$tempAlert(error.response?.data.msg ||"حدث خطأ مشكلة من الخادم.");
      }
    },
    /********************************/
    
  },
};
</script>

<style scoped>
.form-container {
  max-width: 100%;
  margin: 0 auto;
}

.alert {
  margin-top: 20px;
}

.btn {
  padding: 12px;
  font-size: 16px;
}
</style>